import Show from '../Show'
import ShowZzsd from '../Show-zzsd'
import ShowBgy from '../Show-bgy'
import ShowGdnh from '../Show-gdnh'
import ShowNew from '../Show-new'

// 实时统计,这个配置和src\components\yxxc\print\Config.js类似，通过系统配置调整schoolcode来显示对应的页面
export const sstj_school = [
    { dm: 'lydx', mc: '联奕大学', SstjComponent: Show },
    { dm: 'other', mc: '其它基线大学', SstjComponent: ShowZzsd },
    { dm: 'cdfzxx', mc: '成都纺织高等专科学校', SstjComponent: ShowBgy },
    { dm: 'gdnhgs', mc: '广东南华工商职业学院', SstjComponent: ShowGdnh },
    { dm: 'lydx_action', mc: '联奕大学(动)', SstjComponent: ShowNew },
]

//根据schoolcode获取相应的组件
export const getSstjComponent = (school, type) => {
    console.log('schoolCode:', school, type)
    let res = undefined;
    var arr = [...sstj_school];
    arr = arr.filter(item => item.dm == school)
    console.log('sstj_school:', arr)
    if (arr.length > 0) {
        Object.getOwnPropertyNames(arr[0]).some((key) => {
            if (key.includes(type)) {
                res = arr[0][key];
                return true;
            }
        })
    }
    // console.log('getSstjComponent',res)
    return res;
}

export const baseSstjComponent = Show;


// WEBPACK FOOTER //
// ./containers/Sstj/Config.js